<!-- 添加标签 -->
<template>
  <div class="add-label-container">
    <div class="content-container">
      <div class="head-nickname">
        <img :src="userInfo.avatarUrl" class="head-img" alt="">
        <p class="nickname">{{userInfo.nickName}}</p>
      </div>
      <div class="industry-type">
        <p class="hint">请选择您的行业类型</p>
        <div class="item">
          <div class="left-classify" :class="classesId == 1?'sign-tab':''" @click="selectLabel(1)">
            <img class="bg-img" src="@/assets/img/label-classify-1.png" alt="">
            <div class="classify">
              <img class="quotation-mark-icon" src="@/assets/img/quotation-mark.png" alt="">
              <div>学术类</div>
            </div>
          </div>
          <div class="right-classify" :class="classesId == 2?'sign-tab':''" @click="selectLabel(2)">
            <img class="bg-img" src="@/assets/img/label-classify-2.png" alt="">
            <div class="classify">
              <img class="quotation-mark-icon" src="@/assets/img/quotation-mark.png" alt="">
              <div>医院类</div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="left-classify" :class="classesId == 3?'sign-tab':''" @click="selectLabel(3)">
            <img class="bg-img" src="@/assets/img/label-classify-3.png" alt="">
            <div class="classify">
              <img class="quotation-mark-icon" src="@/assets/img/quotation-mark.png" alt="">
              <div>政府类</div>
            </div>
          </div>
          <div class="right-classify" :class="classesId == 4?'sign-tab':''" @click="selectLabel(4)">
            <img class="bg-img" src="@/assets/img/label-classify-4.png" alt="">
            <div class="classify">
              <img class="quotation-mark-icon" src="@/assets/img/quotation-mark.png" alt="">
              <div>制药类</div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="left-classify" :class="classesId == 5?'sign-tab':''" @click="selectLabel(5)">
            <img class="bg-img" src="@/assets/img/label-classify-5.png" alt="">
            <div class="classify">
              <img class="quotation-mark-icon" src="@/assets/img/quotation-mark.png" alt="">
              <div>工业类</div>
            </div>
          </div>
          <div class="right-classify" :class="classesId == 6?'sign-tab':''" @click="selectLabel(6)">
            <img class="bg-img" src="@/assets/img/label-classify-6.png" alt="">
            <div class="classify">
              <img class="quotation-mark-icon" src="@/assets/img/quotation-mark.png" alt="">
              <div>代理商</div>
            </div>
          </div>
        </div>
        <div class="other-item" :class="classesId == -1?'sign-tab':''" @click="otherEvent">
          <img class="bg-img" src="@/assets/img/label-classify-7.png" alt="">
          <div class="classify">
            <img class="quotation-mark-icon" src="@/assets/img/quotation-mark.png" alt="">
            <div>其他类</div>
          </div>
        </div>
      </div>
      <div class="commit-btn">
        <van-button round size="large" color="#6cc4da" @click="commitLabel">提交</van-button>
      </div>
      <van-popup v-model="showPopup" position="bottom" @click-overlay="clickOverlay" :style="{ height: '70%' }">
        <div class="label-popup">
          <div class="header">
            <span>{{detailLabel.name}}</span>
            <div class="right-icon" @click="downPopup">
              <i class="iconfont icon-youjiantou"></i>
            </div>
          </div>
          <div class="label-content">
            <van-button class="label-button" :color="item.pick_on?'#6BC4DA':'#9d9d9d'" :plain="item.pick_on?false:true" @click="labelChange(item)" v-for="(item,index) in detailLabel.children" :key="index">{{item.name}}</van-button>
          </div>
          <div class="bottom-btn-location">
            <div class="bottom-btn">
              <van-button type="primary" color="#6BC4DA" size="large" :round="true" @click="confirm">确定</van-button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
  import { getIndustryLabel, updateTag, getUserInfoData } from '@/api/label'
  import { Base64 } from 'js-base64'
  export default {
    data () {
      return {
        uid: '', // 用户id
        redirect_url: '', // 要重定向的url
        userInfo: {},
        showPopup: false,
        labelList: [],
        detailLabel: [],
        classesId: '', // 行类类型id
        labelId: [] // 行业标签id
      }
    },
    created () {
      var query = this.$route.query
      this.uid = query.uid || ''
      this.redirect_url = query.redirect_url || ''
      this.getUserInfoPort()
      this.getIndustryLabelPort()
    },
    mounted () {

    },
    methods: {
      // 单击类别
      selectLabel (id) {
        var detailLabel = this.labelList.filter((val) => {
          return val.id === id
        })
        this.detailLabel = detailLabel[0]
        this.showPopup = true

        // 重置选中的数据
        if (id !== this.classesId) {
          this.classesId = ''
          this.labelId = []
          this.labelList.map((val) => {
            if (val.children) {
              val.children.map((val2) => {
                this.$set(val2, 'pick_on', false)
              })
            }
          })
        }
      },
      // 选择标签的操作
      labelChange (item) {
        var id = item.id
        var labelList = this.detailLabel.children
        if (this.labelId.indexOf(id) === -1) {
          // 添加标签
          this.labelId.push(id)
          // 为标签替换选中颜色
          labelList.map(val => {
            if (val.id === id) {
              // val.pick_on = true
              this.$set(val, 'pick_on', true)
            }
          })
        } else {
          // 取消标签
          var indexOf = this.labelId.indexOf(id)
          this.labelId.splice(indexOf, 1)
          // 为标签替换未选中颜色
          labelList.map(val => {
            if (val.id === id) {
              // val.pick_on = true
              this.$set(val, 'pick_on', false)
            }
          })
        }
        // this.labelId = item.id
        console.log('选择标签的操作', id, this.labelId)
      },
      // 确定标签
      confirm () {
        // var indexOf = this.detailLabel.children.findIndex(res => res.id === this.labelId)
        if (this.labelId.length === 0) {
          this.$toast('请选择标签')
        } else {
          this.classesId = this.detailLabel.id
          this.showPopup = false
        }
        // console.log('打印indexOf', indexOf)
      },
      // 单击了其他
      otherEvent () {
        this.classesId = -1
        this.labelId = 0
      },
      // 向下按钮关闭遮罩层
      downPopup () {
        this.showPopup = false
      },
      // 点击了遮罩层
      clickOverlay () {
      },
      /** 网络请求 **/
      // 提交数据
      commitLabel () {
        var params = {
          industry: [this.classesId, this.labelId],
          id: this.uid
        }
        if (this.classesId === -1) {
          params.industry = [7, []]
        }
        if (!this.classesId) {
          this.$toast('请选择行业类型')
        } else {
          console.log('提交的数据', params)
          console.log('解密', Base64.decode(this.redirect_url))
          var redirectUrl = Base64.decode(this.redirect_url)
          updateTag(params).then(res => {
            if (res.errCode === 0) {
              this.$toast('提交成功')
              const timer = setTimeout(() => {
                window.location.href = redirectUrl
                clearTimeout(timer)
              }, 800)
            } else {
              this.$toast(res.errMsg)
            }
          }).catch(err => {
            console.log('提交失败,接口报错', err)
            this.$toast('提交失败,接口报错')
          })
        }
      },
      // 获取用户数据
      getUserInfoPort () {
        var params = {
          id: this.uid
        }
        getUserInfoData(params).then(res => {
          if (res.errCode === 0) {
            this.userInfo = res.data
          } else {
            this.$toast(res.errMsg)
          }
        }).catch(err => {
          console.log('获取用户信息接口报错', err)
          this.$toast('用户信息接口失败')
        })
      },
      // 获取类型数据
      getIndustryLabelPort () {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        getIndustryLabel().then(res => {
          if (res.errCode === 0) {
            var data = res.data
            this.labelList = data
            this.$toast.clear()
          } else {
            this.$toast.clear()
            this.$toast(res.errMsg)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .add-label-container {
    width: 100%;
    height: 100vh;
    padding: 0 rem(47);
    &:after{
      content: '';
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background: #f7f8fb;
      z-index: -1;
    }

    .content-container {
      padding-top: rem(25);
      width: 100%;

      .head-nickname {
        text-align: center;

        .head-img {
          width: rem(62);
          height: rem(62);
          border-radius: 50%;
        }

        .nickname {
          color: #333333;
          font-size: rem(15);
        }
      }

      .industry-type {
        .hint {
          color: #333333;
          font-size: rem(16);
          margin: rem(12) 0;
          text-align: center;
        }

        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: rem(13);

          .left-classify, .right-classify {
            width: rem(134);
            height: rem(80);
            box-shadow: 0 0 14px -5px #cfcfcf;
            border-radius: 4px;
            background-image: linear-gradient(to bottom right, #eff9fd, white);
            position: relative;
            overflow: hidden;

            .bg-img {
              width: 90%;
              height: auto;
              position: absolute;
              top: rem(6);
              right: rem(5);
              z-index: 0;
            }

            .classify {
              padding-left: rem(14);
              width: 100%;
              height: 100%;
              position: relative;
              z-index: 3;
              font-size: rem(15);
              color: #2C2C2C;
              font-weight: bold;

              .quotation-mark-icon {
                width: rem(12);
                height: rem(9);
              }
            }
          }
          .sign-tab {
            box-shadow: 0 0 14px 5px #cfcfcf;
            background-image: linear-gradient(to bottom right, #8ddef3 , white);
            transition: all .2s;
            transform: scale(1.1);
          }
        }
        .other-item {
          width: 100%;
          height: rem(80);
          margin-bottom: rem(20);
          box-shadow: 0 0 14px -5px #cfcfcf;
          border-radius: 4px;
          background-image: linear-gradient(to bottom right, #eff9fd, white);
          position: relative;

          .bg-img {
            width: 95%;
            height: auto;
            position: absolute;
            top: rem(6);
            right: rem(5);
          }

          .classify {
            padding-left: rem(14);
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 3;
            font-size: rem(15);
            color: #2C2C2C;
            font-weight: bold;

            .quotation-mark-icon {
              width: rem(12);
              height: rem(9);
            }
          }
        }
        .sign-tab {
          box-shadow: 0 0 14px 5px #cfcfcf;
          background-image: linear-gradient(to bottom right, #8ddef3 , white);
          transition: all .2s;
          transform: scale(1.1);
        }
      }

      .commit-btn {
        width: 80%;
        margin: 0 auto;
        margin-bottom: rem(20);
      }

      .label-popup {
        .header {
          text-align: center;
          color: #2C2C2C;
          font-size: rem(16);
          font-weight: bold;
          height: rem(45);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;

          .right-icon {
            transform: rotate(90deg);
            width: rem(45);
            height: rem(45);
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon-youjiantou {
              font-size: rem(25);
              color: #9D9D9D;
            }
          }
        }
        .label-content{
          padding: rem(10) rem(20);
          .label-button{
            height: rem(30);
            border-radius: rem(6);
            margin-right: rem(12);
            margin-bottom: rem(12);
          }
          .van-button{
            line-height: rem(30);
          }
        }
        .bottom-btn-location{
          position: absolute;
          bottom: rem(35);
          width: 100%;
          .bottom-btn{
            width: 80%;
            margin: 0 auto;
          }
        }

      }
    }
  }
</style>
